import { Routes } from '@angular/router';
import { authGuard } from './core/auth/auth.guard';

export const routes: Routes = [
  // Public landing page
  {
    path: 'landing',
    loadComponent: () => import('./features/landing/landing.component').then((m) => m.LandingComponent),
  },

  // MSAL popup redirect handler — must be outside the shell and authGuard
  {
    path: 'auth-redirect',
    loadComponent: () => import('./features/auth-redirect/auth-redirect.component').then((m) => m.AuthRedirectComponent),
  },

  // Protected app shell
  {
    path: '',
    loadComponent: () => import('./layout/shell.component').then((m) => m.ShellComponent),
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        loadComponent: () => import('./features/dashboard/dashboard.component').then((m) => m.DashboardComponent),
      },
      {
        path: 'accounts',
        loadComponent: () => import('./features/accounts/accounts.component').then((m) => m.AccountsComponent),
      },
      {
        path: 'receipts',
        loadComponent: () => import('./features/receipts/receipts.component').then((m) => m.ReceiptsComponent),
      },
      {
        path: 'registry',
        loadComponent: () => import('./features/registry/registry.component').then((m) => m.RegistryComponent),
      },
      {
        path: 'bills',
        loadComponent: () => import('./features/bills/bills.component').then((m) => m.BillsComponent),
      },
      {
        path: 'income',
        loadComponent: () => import('./features/income/income.component').then((m) => m.IncomeComponent),
      },
      {
        path: 'budget',
        loadComponent: () => import('./features/budget/budget.component').then((m) => m.BudgetComponent),
      },
    ],
  },

  { path: '**', redirectTo: 'landing' },
];
